import React from "react";
import s from "./styles.module.scss";

class AuthErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Auth Error Boundary caught an error:", error, errorInfo);

    // Handle Clerk-specific errors by checking error structure
    if (error && error.errors && Array.isArray(error.errors)) {
      const clerkError = error.errors[0];
      console.error("Clerk API Error:", {
        code: clerkError.code,
        message: clerkError.message,
        longMessage: clerkError.longMessage,
        meta: clerkError.meta,
      });
    }

    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      let errorMessage = "An authentication error occurred. Please try again.";

      // Handle specific Clerk errors by checking error structure
      if (
        error &&
        error.errors &&
        Array.isArray(error.errors) &&
        error.errors[0]
      ) {
        const clerkError = error.errors[0];

        switch (clerkError.code) {
          case "form_identifier_not_found":
            errorMessage =
              "Email address not found. Please check your email or sign up.";
            break;
          case "form_password_incorrect":
            errorMessage = "Incorrect password. Please try again.";
            break;
          case "form_identifier_exists":
            errorMessage =
              "This email is already registered. Please sign in instead.";
            break;
          case "session_exists":
            errorMessage = "You are already signed in.";
            break;
          case "authentication_invalid":
            errorMessage = "Invalid authentication. Please sign in again.";
            break;
          case "too_many_requests":
            errorMessage =
              "Too many attempts. Please wait a moment and try again.";
            break;
          default:
            errorMessage = clerkError.message || errorMessage;
        }
      } else if (error && error.message) {
        errorMessage = error.message;
      }

      return (
        <div className={s.errorBoundaryContainer}>
          <div className={s.errorBoundaryContent}>
            <h2>Authentication Error</h2>
            <p className={s.errorMessage}>{errorMessage}</p>
            <div className={s.errorActions}>
              <button
                onClick={() => (window.location.href = "/")}
                className={s.errorButton}
              >
                Go to Home
              </button>
              <button
                onClick={() => window.location.reload()}
                className={`${s.errorButton} ${s.secondary}`}
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AuthErrorBoundary;
